import firebase from "firebase";
import { getCollection } from "../constant";

export class UploadAdapter {
  constructor(loader, projectId, profile, firestore) {
    this.loader = loader;
    this.projectId = projectId;
    this.profile = profile;
    this.firestore = firestore;
    this.upload = this.upload.bind(this);
    // this.abort = this.abort.bind(this);
  }

  upload() {
    return new Promise(async (resolve, reject) => {
      this.loader.file.then((file) => {
        console.log("file : ", file);

        const uploadTask = firebase
          .storage()
          .ref("project-files")
          .child(`${this.projectId}/${file.name}`)
          .put(file); //create a child directory called images, and place the file inside this directory
        uploadTask.on(
          "state_changed",
          (snapshot) => {},
          (error) => {},
          (url) => {
            console.log("url : ", url);
            return this.afterUpload(file.name).then((url) => {
              console.log(url);
              resolve({
                default: url,
              });
            });

            // Do something once upload is complete
            console.log("success");
          }
        );
      });
    });
  }

  afterUpload(filename) {
    return new Promise(async (resolve, reject) => {
      const { id, displayName } = this.profile;
      const downloadURL = await firebase
        .storage()
        .ref("project-files")
        .child(this.projectId)
        .child(filename)
        .getDownloadURL();

      firebase
        .storage()
        .ref("project-files")
        .child(this.projectId)
        .child(filename)
        .getMetadata()
        .then((metaData) => {
          const fileData = {
            url: downloadURL,
            parentId: this.projectId,
            userName: displayName,
            userId: id,
          };
          Object.keys(metaData).forEach((key) => {
            if (metaData[key]) {
              fileData[key] = metaData[key];
            }
          });

          this.firestore
            .add({ collection: getCollection(this.profile, "files") }, fileData)
            .then(
              (data) => {
                resolve(downloadURL);
              },
              (err) => {}
            );
        });
    });
  }
}
